<template>
	<div>
		<filter-panel :data="groups" @change="change" @search="filterChange"></filter-panel>
		<data-list
			ref="datalist"
			height="600"
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:btnList="btnList"
			:page="page"
			:loading="loading"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		>
		</data-list>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import { termsType, searchTermsStatus, searchTermsMark } from '@/common/dictionary';
import website from '@/backend/services/website/website.js';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import { getDateRegion } from '@/common/util.js';
const list = listPageCreate({
	searchConfig: {
		api: api.website.searchTermsHistoryList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let { serviceId } = that.$route.query;
		obj.startDate = that.groups.others[0].value[0];
		obj.endDate = that.groups.others[0].value[1];
		return _.assign(obj, {
			serviceId,
		});
	},
});
export default {
	mixins: [list],
	data() {
		return {
			groups: {},
			columns: [],
			btnList: [],
			startDate: '',
			endDate: '',
		};
	},
	mounted() {
		this.getGroups();
		this.query();
		this.setcolumns();
		this.setSerieslist();
	},
	methods: {
		getGroups() {
			let date = getDateRegion('DAYS_7', 'YYYY-MM-DD', '&').split('&');
			this.startDate = date[0];
			this.endDate = date[1];
			this.groups = {
				multiples: [
					{
						label: '类型',
						defaultText: '类型',
						placeholder: '全部',
						options: termsType,
						prop: 'searchTermType',
						value: '',
					},
					{
						label: '状态',
						defaultText: '状态',
						placeholder: '全部',
						options: searchTermsStatus,
						prop: 'searchTermStatus',
						value: '',
					},
					{
						label: '标记',
						defaultText: '标记',
						placeholder: '全部',
						options: searchTermsMark,
						prop: 'mark',
						value: '',
					},
					{
						label: '广告系列',
						placeholder: '全部',
						defaultText: '广告系列',
						multiple: true,
						options: [],
						props: {
							label: 'campaignName',
							value: 'campaignId',
						},
						prop: 'campaignIdList',
						value: [],
					},
					{
						label: '广告组',
						placeholder: '全部',
						defaultText: '广告组',
						multiple: true,
						options: [],
						props: {
							label: 'adGroupName',
							value: 'adGroupId',
						},
						prop: 'adGroupIdList',
						value: [],
					},
				],
				others: [
					{
						tagName: 'sky-date-picker',
						type: 'daterange',
						inputTitle: '提交日期',
						label: '提交日期',
						startPlaceholder: '开始日期',
						endPlaceholder: '结束日期',
						prop: ['startDate', 'endDate'],
						value: [this.startDate,this.endDate],
					},
				],
			};
		},
		change(row, val) {
			if (row.label == '广告系列' && val.length !== 0) {
				this.setAdGroupIdList(val);
			}
			if (row.label == '广告系列' && val.length === 0) {
				this.groups.multiples.forEach(item => {
					if (item.label === '广告组') {
						item.options = [];
					}
				});
			}
		},
		async setSerieslist() {
			let { serviceId } = this.$route.query;
			let res = await website.advertisingSubmitSeries({
				service_id: serviceId,
			});
			this.groups.multiples.forEach(item => {
				if (item.label === '广告系列') {
					item.options = res.data;
				}
			});
		},
		async setAdGroupIdList(val) {
			let { serviceId } = this.$route.query;
			let res = await website.advertisingSubmitGroup({
				id: val,
				service_id: serviceId,
			});
			this.groups.multiples.forEach(item => {
				if (item.label === '广告组') {
					item.options = res.data;
				}
			});
		},
		setcolumns() {
			let that = this;
			this.columns = [
				{
					label: '搜索词',
					type: 'tooltip',
					bind: 'searchTermName',
					tag(val, row) {
						if (row.searchTermType) {
							return { content: '自定义' };
						} else {
							return false;
						}
					},
				},
				{
					label: '匹配类型',
					type: 'percentage',
					bind: 'searchTermMatchType',
					showOverflowTooltip: true,
					content: '在Google上触发广告的搜索字词与您账号中实际关键字的相关程度',
					style: {
						overflow: 'hidden',
						'text-overflow': 'ellipsis',
						'white-space': 'nowrap',
					},
					dataStyle(val) {
						switch (val) {
							case '1':
								return '广泛匹配';
							case '2':
								return '完全匹配';
							case '3':
								return '精确匹配（紧密变体）';
							case '4':
								return '词组匹配（紧密变体）';
							case '5':
								return '词组匹配';
              case '8':
								return 'Ai Max';
							case '9':
								return 'Performance Max';
							default:
								return '-';
						}
					},
				},
				{
					label: '状态',
					type: 'textStatus',
					bind: 'searchTermStatus',
					content: '是否已经将当前搜索词作为关键字或否定关键字添加到账户中',
					width: 125,
					dataStyle(val) {
						switch (val) {
							case '1':
								return '已添加';
							case '2':
								return '已添加/已排除';
							case '3':
								return '已排除';
							case '4':
								return '未知';
						}
					},
					statusSty(val) {
						switch (val) {
							case '1':
								return {
									color: '#3DA1FF',
								};
							case '2':
								return {
									color: '#FF9FA4',
								};
							case '3':
								return {
									color: '#4FD2AA',
								};
							case '4':
								return {
									color: '#999999',
								};
						}
					},
				},
				{
					label: '关键词',
					bind: 'keywordsName',
					showOverflowTooltip: true,
				},
				{
					label: '广告系列',
					bind: 'campaignName',
					showOverflowTooltip: true,
					minWidth: 125,
				},
				{
					label: '广告组',
					bind: 'adGroupName',
					showOverflowTooltip: true,
					minWidth: 125,
				},
				{
					label: '提交日期',
					bind: 'createTime',
					showOverflowTooltip: true,
					width: 160,
				},
				{
					label: '提交人',
					bind: 'createName',
					showOverflowTooltip: true,
					width: 125,
				},
				{
					label: '标记',
					type: 'percentage',
					bind: 'mark',
					content:
						'添加：您可以根据此报告找出用户极有可能使用的新搜索字词，并将其添加到关键字列表中 排除：还可以寻找与您的业务不相关的搜索字词，将其添加为否定关键字，避免浪费资金',
					width: 100,
					dataStyle(val) {
						switch (val) {
							case 0:
								return '无';
							case 1:
								return '添加';
							case 2:
								return '取消添加';
							case 3:
								return '排除';
							case 4:
								return '取消排除';
						}
					},
				},
			];
			this.btnList = [
				{
					name: '导出',
					position: 'right',
					attribute: {
						type: 'primary',
						size: 'mini',
					},
					btnClick() {
						that.SubmitDownload();
					},
				},
			];
		},
		async SubmitDownload() {
			let { serviceId } = this.$route.query;
			let params = {};
			this.groups.multiples.forEach(({ prop, value }) => {
				params[prop] = value;
			});
			this.groups.others.forEach(({ prop, value }) => {
				params[prop[0]] = value[0];
				params[prop[1]] = value[1];
			});
			let res = await website.advertisingSubmitDownload({
				...params,
				serviceId,
			});
			if (!res.data) {
				this.$message.info('所选时间段暂无数据');
				return false;
			}
			let blob = new Blob([res.data]);
			let url = window.URL.createObjectURL(blob);
			let link = document.createElement('a');
			link.style.display = 'none';
			link.href = url;
			link.setAttribute('download', '搜索词报告.xlsx');
			document.body.appendChild(link);
			link.click();
		},
	},
	components: { filterPanel },
};
</script>

<style></style>
